export interface CountryCallingCode {
  code: string;
  name: string;
  dialCode: string;
  placeholder?: string;
}

export function getFlagEmoji(countryCode: string): string {
  return countryCode
    .toUpperCase()
    .split('')
    .map(c => String.fromCodePoint(0x1f1e0 + c.charCodeAt(0) - 65))
    .join('');
}

export const COUNTRY_CALLING_CODES: CountryCallingCode[] = [
  {code: 'MZ', name: 'Moçambique', dialCode: '+258', placeholder: '84 123 4567'},
  {code: 'AO', name: 'Angola', dialCode: '+244', placeholder: '923 123 456'},
  {code: 'ZA', name: 'África do Sul', dialCode: '+27', placeholder: '71 123 4567'},
  {code: 'ZW', name: 'Zimbabwe', dialCode: '+263', placeholder: '71 123 4567'},
  {code: 'ZM', name: 'Zâmbia', dialCode: '+260', placeholder: '97 123 4567'},
  {code: 'TZ', name: 'Tanzânia', dialCode: '+255', placeholder: '74 123 4567'},
  {code: 'KE', name: 'Quénia', dialCode: '+254', placeholder: '712 345 678'},
  {code: 'UG', name: 'Uganda', dialCode: '+256', placeholder: '712 345 678'},
  {code: 'RW', name: 'Ruanda', dialCode: '+250', placeholder: '78 123 4567'},
  {code: 'BI', name: 'Burundi', dialCode: '+257', placeholder: '79 561 234'},
  {code: 'MW', name: 'Malawi', dialCode: '+265', placeholder: '991 234 567'},
  {code: 'NG', name: 'Nigéria', dialCode: '+234', placeholder: '802 123 4567'},
  {code: 'GH', name: 'Gana', dialCode: '+233', placeholder: '23 123 4567'},
  {code: 'ET', name: 'Etiópia', dialCode: '+251', placeholder: '91 123 4567'},
  {code: 'SD', name: 'Sudão', dialCode: '+249', placeholder: '91 123 4567'},
  {code: 'EG', name: 'Egito', dialCode: '+20', placeholder: '101 234 5678'},
  {code: 'MA', name: 'Marrocos', dialCode: '+212', placeholder: '650 123 456'},
  {code: 'TN', name: 'Tunísia', dialCode: '+216', placeholder: '20 123 456'},
  {code: 'DZ', name: 'Argélia', dialCode: '+213', placeholder: '551 234 567'},
  {code: 'LY', name: 'Líbia', dialCode: '+218', placeholder: '91 234 5678'},
  {code: 'SN', name: 'Senegal', dialCode: '+221', placeholder: '70 123 4567'},
  {code: 'CI', name: 'Costa do Marfim', dialCode: '+225', placeholder: '01 234 5678'},
  {code: 'CM', name: 'Camarões', dialCode: '+237', placeholder: '6 71 23 45 67'},
  {code: 'CD', name: 'Congo (RDC)', dialCode: '+243', placeholder: '991 234 567'},
  {code: 'CG', name: 'Congo', dialCode: '+242', placeholder: '06 123 4567'},
  {code: 'BW', name: 'Botswana', dialCode: '+267', placeholder: '71 123 456'},
  {code: 'NA', name: 'Namíbia', dialCode: '+264', placeholder: '81 123 4567'},
  {code: 'SZ', name: 'Eswatini', dialCode: '+268', placeholder: '7612 3456'},
  {code: 'LS', name: 'Lesoto', dialCode: '+266', placeholder: '5012 3456'},
  {code: 'MG', name: 'Madagáscar', dialCode: '+261', placeholder: '32 12 345 67'},
  {code: 'MU', name: 'Maurício', dialCode: '+230', placeholder: '5251 2345'},
  {code: 'CV', name: 'Cabo Verde', dialCode: '+238', placeholder: '991 12 34'},
  {code: 'ST', name: 'São Tomé e Príncipe', dialCode: '+239', placeholder: '981 2345'},
  {code: 'GW', name: 'Guiné-Bissau', dialCode: '+245', placeholder: '955 012 345'},
  {code: 'GQ', name: 'Guiné Equatorial', dialCode: '+240', placeholder: '222 123 456'},
  {code: 'GA', name: 'Gabão', dialCode: '+241', placeholder: '06 03 12 34'},
  {code: 'BJ', name: 'Benim', dialCode: '+229', placeholder: '90 01 12 34'},
  {code: 'BF', name: 'Burkina Faso', dialCode: '+226', placeholder: '70 12 34 56'},
  {code: 'ML', name: 'Mali', dialCode: '+223', placeholder: '65 01 23 45'},
  {code: 'NE', name: 'Níger', dialCode: '+227', placeholder: '93 12 34 56'},
  {code: 'TD', name: 'Chade', dialCode: '+235', placeholder: '63 01 23 45'},
  {code: 'SS', name: 'Sudão do Sul', dialCode: '+211', placeholder: '977 123 456'},
  {code: 'SO', name: 'Somália', dialCode: '+252', placeholder: '7 1123 4567'},
  {code: 'DJ', name: 'Djibuti', dialCode: '+253', placeholder: '77 83 10 01'},
  {code: 'ER', name: 'Eritreia', dialCode: '+291', placeholder: '7 123 456'},
  {code: 'KM', name: 'Comores', dialCode: '+269', placeholder: '321 23 45'},
  {code: 'SC', name: 'Seicheles', dialCode: '+248', placeholder: '2 510 123'},
  {code: 'PT', name: 'Portugal', dialCode: '+351', placeholder: '912 345 678'},
  {code: 'BR', name: 'Brasil', dialCode: '+55', placeholder: '11 91234-5678'},
  {code: 'US', name: 'Estados Unidos', dialCode: '+1', placeholder: '201 555 0123'},
  {code: 'CA', name: 'Canadá', dialCode: '+1', placeholder: '506 234 5678'},
  {code: 'GB', name: 'Reino Unido', dialCode: '+44', placeholder: '7400 123456'},
  {code: 'FR', name: 'França', dialCode: '+33', placeholder: '06 12 34 56 78'},
  {code: 'DE', name: 'Alemanha', dialCode: '+49', placeholder: '1512 3456789'},
  {code: 'ES', name: 'Espanha', dialCode: '+34', placeholder: '612 34 56 78'},
  {code: 'IT', name: 'Itália', dialCode: '+39', placeholder: '312 345 6789'},
  {code: 'NL', name: 'Países Baixos', dialCode: '+31', placeholder: '6 12345678'},
  {code: 'BE', name: 'Bélgica', dialCode: '+32', placeholder: '470 12 34 56'},
  {code: 'CH', name: 'Suíça', dialCode: '+41', placeholder: '78 123 45 67'},
  {code: 'SE', name: 'Suécia', dialCode: '+46', placeholder: '70 123 45 67'},
  {code: 'NO', name: 'Noruega', dialCode: '+47', placeholder: '406 12 345'},
  {code: 'DK', name: 'Dinamarca', dialCode: '+45', placeholder: '32 12 34 56'},
  {code: 'FI', name: 'Finlândia', dialCode: '+358', placeholder: '41 2345678'},
  {code: 'PL', name: 'Polónia', dialCode: '+48', placeholder: '512 345 678'},
  {code: 'RU', name: 'Rússia', dialCode: '+7', placeholder: '912 345-67-89'},
  {code: 'CN', name: 'China', dialCode: '+86', placeholder: '131 2345 6789'},
  {code: 'IN', name: 'Índia', dialCode: '+91', placeholder: '81234 56789'},
  {code: 'JP', name: 'Japão', dialCode: '+81', placeholder: '90-1234-5678'},
  {code: 'KR', name: 'Coreia do Sul', dialCode: '+82', placeholder: '10-1234-5678'},
  {code: 'AU', name: 'Austrália', dialCode: '+61', placeholder: '412 345 678'},
  {code: 'NZ', name: 'Nova Zelândia', dialCode: '+64', placeholder: '21 123 4567'},
  {code: 'AR', name: 'Argentina', dialCode: '+54', placeholder: '11 1234-5678'},
  {code: 'CL', name: 'Chile', dialCode: '+56', placeholder: '9 1234 5678'},
  {code: 'CO', name: 'Colômbia', dialCode: '+57', placeholder: '321 1234567'},
  {code: 'MX', name: 'México', dialCode: '+52', placeholder: '222 123 4567'},
  {code: 'PE', name: 'Peru', dialCode: '+51', placeholder: '912 345 678'},
  {code: 'VE', name: 'Venezuela', dialCode: '+58', placeholder: '412 1234567'},
  {code: 'SA', name: 'Arábia Saudita', dialCode: '+966', placeholder: '51 234 5678'},
  {code: 'AE', name: 'Emirados Árabes', dialCode: '+971', placeholder: '50 123 4567'},
  {code: 'TR', name: 'Turquia', dialCode: '+90', placeholder: '501 234 5678'},
  {code: 'PK', name: 'Paquistão', dialCode: '+92', placeholder: '301 2345678'},
  {code: 'BD', name: 'Bangladesh', dialCode: '+880', placeholder: '1812-345678'},
  {code: 'ID', name: 'Indonésia', dialCode: '+62', placeholder: '812-345-678'},
  {code: 'PH', name: 'Filipinas', dialCode: '+63', placeholder: '905 123 4567'},
  {code: 'VN', name: 'Vietname', dialCode: '+84', placeholder: '91 234 56 78'},
  {code: 'TH', name: 'Tailândia', dialCode: '+66', placeholder: '81 234 5678'},
];

export const DEFAULT_COUNTRY = COUNTRY_CALLING_CODES[0];
